// Module
var code = `<inline-panel on-hide="\$ctrl.onHide()">
  <div class="inline-panel__list" ng-class="{'inline-panel__list-loading': !\$ctrl.keyValueDetails.length}">
    <div class="inline-panel__container"
         ng-repeat="item in \$ctrl.keyValueDetails">
      <label class="inline-panel__label">{{item.label | prettyEnum}}:</label>
      <p class="inline-panel__value" ng-if="item.type === 'STATIC'">{{item.value}}</p>
      <p class="inline-panel__value" ng-if="item.type === 'ATTRIBUTE'">{{item.value | prettyEnum}}</p>
      <p class="inline-panel__value" ng-if="item.type === 'CASH'">{{item.value | nxCurrency}}</p>
    </div>
  </div>
  <table class="table transaction-details-table">
    <thead>
      <th>Account code</th>
      <th>Debit amount</th>
      <th>Credit amount</th>
      <th>Remarks</th>
    </thead>
    <tbody>
      <tr ng-repeat="transactionUnit in \$ctrl.transaction.transactionUnits">
        <td class="account-code">
          {{transactionUnit.ledgerAccountCode}}
          <i class="icon-info-sign account-name" title="{{transactionUnit.ledgerAccountName}}">
          </i>
        </td>
        <td ng-bind-html="\$ctrl.formatDebit(transactionUnit)"></td>
        <td ng-bind-html="\$ctrl.formatCredit(transactionUnit)"></td>
        <td>{{transactionUnit.remarks ? transactionUnit.remarks : "-"}}</td>
      </tr>
    </tbody>
  </table>
  <div class="inline-panel-footer"
      ng-if="\$ctrl.transaction.transactionType === 'MANUAL'">
    <div class="inline-panel__container">
      <label class="inline-panel__label">Revoked by:</label>
      <p class="inline-panel__value">{{\$ctrl.transaction.rejectionUser}}</p>
    </div>
    <div class="inline-panel__container">
      <label class="inline-panel__label">Revoked on:</label>
      <p class="inline-panel__value">{{\$ctrl.transaction.rejectionTime}}</p>
    </div>
    <button type="button" ng-if="\$ctrl.transaction.revokeAction"
            class="btn btn-danger"
            ng-click="\$ctrl.onRevoke()">
      Revoke
    </button>
  </div>
</inline-panel>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/transactions/gl-transaction-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;